import { CredentialField } from "../shared/CredentialField";

export const AmplitudeCredentialsForm = ({
  credentials,
  onCredentialsChange,
}) => {
  const handleChange = (field) => (value) => {
    onCredentialsChange((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div className="px-6 pb-4">
      <h3 className="mb-2 text-lg font-semibold text-gray-900">
        Enter your Amplitude credentials
      </h3>
      <p className="mb-4 text-sm text-gray-500">
        You&apos;ll need your API Key and Secret Key from Amplitude to connect.
        Find these in Amplitude Settings &gt; Projects &gt; API Keys.
      </p>

      <div className="space-y-4">
        <CredentialField
          id="amplitude_api_key"
          label="API Key"
          tooltip="Find this in Amplitude Settings > Projects > API Keys"
          placeholder="Enter your Amplitude API Key"
          value={credentials.api_key}
          onChange={handleChange("api_key")}
        />
        <CredentialField
          id="amplitude_secret_key"
          label="Secret Key"
          type="password"
          tooltip="Find this in Amplitude Settings > Projects > API Keys"
          placeholder="Enter your Amplitude Secret Key"
          value={credentials.secret_key}
          onChange={handleChange("secret_key")}
        />
        <div>
          <label
            htmlFor="amplitude_region"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            Data Residency
          </label>
          <select
            id="amplitude_region"
            className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500"
            value={credentials.region || "US"}
            onChange={(e) => handleChange("region")(e.target.value)}
          >
            <option value="US">United States (US)</option>
            <option value="EU">European Union (EU)</option>
          </select>
          <p className="mt-1 text-xs text-gray-500">
            Select EU if your Amplitude project uses EU data residency.
          </p>
        </div>
      </div>
    </div>
  );
};
